import { render, staticRenderFns } from "./SvgValueZones.vue?vue&type=template&id=40eb532b"
import script from "./SvgValueZones.vue?vue&type=script&lang=js"
export * from "./SvgValueZones.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports